// extracted by mini-css-extract-plugin
export default {"team_name":"TeamsTable_team_name__2QIQV","companyContainer":"TeamsTable_companyContainer__2H-NT"};